import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamWidgetComponent } from './team-widget/team-widget.component';
import { WidgetDirective } from './widget.directive';
import { VtrWidgetComponent } from './vtr-widget/vtr-widget.component';
import { SprintinfoWidgetComponent } from './sprintinfo-widget/sprintinfo-widget.component';
import { AppMaterialModule } from '../../app-material.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { SettingsWidgetComponent } from './settings-widget/settings-widget.component';
import { ProjectWidgetComponent } from './project-widget/project-widget.component';
import { StickerWidgetComponent } from './sticker-widget/sticker-widget.component';
import { StickerIconComponent } from './sticker-widget/sticker-icon/sticker-icon.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalleryWidgetComponent } from './gallery-widget/gallery-widget.component';
import { RotationImageComponent } from './gallery-widget/gallery-small-view/rotation-image/rotation-image.component';
import { GalleryViewOrderedComponent } from './gallery-widget/gallery-ordered-view/gallery-view-ordered.component';
import { GalleryViewOrderedDirective } from './gallery-widget/gallery-ordered-view/gallery-view-ordered.directive';
import { GalleryViewSmallComponent } from './gallery-widget/gallery-small-view/gallery-view-small.component';
import { GalleryViewSmallDirective } from './gallery-widget/gallery-small-view/gallery-view-small.directive';
import { GalleryImageComponent } from './gallery-widget/gallery-image/gallery-image.component';
import { GalleryImageDirective } from './gallery-widget/gallery-image/gallery-image.directive';
import { ToggleModule } from './gallery-widget/toggle/toggle.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClonedImageComponent } from './gallery-widget/gallery-image/cloned-image/cloned-image.component';
import { ClonedImageDirective } from './gallery-widget/gallery-image/cloned-image/cloned-image.directive';
import { SprintplanningWidgetComponent } from './sprintplanning-widget/sprintplanning-widget.component';
import { WhiteboardWidgetComponent } from './whiteboard-widget/whiteboard-widget.component';
import { BurndownWidgetComponent } from './burndown-widget/burndown-widget.component';
import { PiWidgetComponent } from './pi-widget/pi-widget.component';
import { ReleaseplanningWidgetComponent } from './releaseplanning-widget/releaseplanning-widget.component';
import { AppWidgetComponent } from './app-widget/app-widget.component';
import { DefinitionOfDoneWidgetComponent } from './definition-of-done-widget/definition-of-done-widget.component';
import { TeamMoodComponent } from './team-mood/team-mood.component';
import { TeamMoodDataCollectionComponent } from './team-mood/team-mood-data-collection/team-mood-data-collection.component';
import { TeamMoodFeedbackComponent } from './team-mood/team-mood-feedback/team-mood-feedback.component';
import { TeamMoodQuestionEditComponent } from './team-mood/team-mood-question-edit/team-mood-question-edit.component';
// eslint-disable-next-line max-len
import { TeamMoodSprintAvgChartComponent } from './team-mood/team-mood-sprint-avg-chart/team-mood-sprint-avg-chart.component';
// eslint-disable-next-line max-len
import { TeamMoodTimeRangeChartComponent } from './team-mood/team-mood-time-range-chart/team-mood-time-range-chart.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { QRCodeModule } from 'angularx-qrcode';
import { WidgetWrapperComponent } from '../widget-wrapper/widget-wrapper.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { TeamMoodVotingAvgComponent } from './team-mood/team-mood-voting-avg/team-mood-voting-avg.component';
import { FilterWidgetComponent } from './filter-widget/filter-widget.component';
import { AssetIconModule } from '../asset-icon/asset-icon.module';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';
import { ChatWidgetActionItemComponent} from './chat-widget/action-item/action-item.component';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CopilotWidgetComponent } from './copilot-widget/copilot-widget.component';
import { ActionItemComponent } from './copilot-widget/action-item/action-item.component';
import { ActionItemUpdateComponent } from './copilot-widget/action-item-update/action-item-update.component';

@NgModule({
  imports: [
  CommonModule,
  AppMaterialModule,
  TranslateModule,
  FormsModule,
  ToggleModule,
  NgbModule,
  ReactiveFormsModule,
  NgMultiSelectDropDownModule,
  MatTableModule,
  MatProgressSpinnerModule,
  QRCodeModule,
  ColorPickerModule,
  AssetIconModule,
  DirectivesModule,
  PipesModule,
  ],
  declarations: [
  WidgetWrapperComponent,
  WidgetDirective,
  TeamWidgetComponent,
  SprintinfoWidgetComponent,
  SprintplanningWidgetComponent,
  ReleaseplanningWidgetComponent,
  VtrWidgetComponent,
  SettingsWidgetComponent,
  ProjectWidgetComponent,
  FilterWidgetComponent,
  PiWidgetComponent,
  GalleryWidgetComponent,
  RotationImageComponent,
  GalleryViewOrderedComponent,
  GalleryViewOrderedDirective,
  GalleryViewSmallComponent,
  GalleryViewSmallDirective,
  GalleryImageComponent,
  GalleryImageDirective,
  ClonedImageComponent,
  ClonedImageDirective,
  WhiteboardWidgetComponent,
  BurndownWidgetComponent,
  AppWidgetComponent,
  DefinitionOfDoneWidgetComponent,
  TeamMoodComponent,
  TeamMoodDataCollectionComponent,
  TeamMoodFeedbackComponent,
  TeamMoodQuestionEditComponent,
  TeamMoodSprintAvgChartComponent,
  TeamMoodTimeRangeChartComponent,
  TeamMoodVotingAvgComponent,
  StickerWidgetComponent,
  StickerIconComponent,
  ChatWidgetComponent,
  ChatWidgetActionItemComponent,
  CopilotWidgetComponent,
  ActionItemComponent,
  ActionItemUpdateComponent,
  ],
  exports: [
  WidgetWrapperComponent,
  WidgetDirective,
  TeamWidgetComponent,
  CopilotWidgetComponent,
  SprintinfoWidgetComponent,
  SprintplanningWidgetComponent,
  VtrWidgetComponent,
  SettingsWidgetComponent,
  ProjectWidgetComponent,
  FilterWidgetComponent,
  PiWidgetComponent,
  ReleaseplanningWidgetComponent,
  WhiteboardWidgetComponent,
  GalleryWidgetComponent,
  BurndownWidgetComponent,
  AppWidgetComponent,
  DefinitionOfDoneWidgetComponent,
  TeamMoodComponent,
  StickerWidgetComponent,
  FilterWidgetComponent,
  ChatWidgetComponent,
  ChatWidgetActionItemComponent
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  })
export class WidgetModule {}
